import { type ReactNode } from 'react';

import { AuthProvider } from './AuthContext';
import { SidebarProvider } from './SidebarContext';
import { ThemeProvider } from './ThemeContext';
import { ToastProvider } from './ToastContext';

export function AppProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <SidebarProvider>{children}</SidebarProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
